import { render, staticRenderFns } from "./tenderDocumentClarification.vue?vue&type=template&id=88014794&scoped=true"
import script from "./tenderDocumentClarification.vue?vue&type=script&lang=js"
export * from "./tenderDocumentClarification.vue?vue&type=script&lang=js"
import style0 from "./tenderDocumentClarification.vue?vue&type=style&index=0&id=88014794&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88014794",
  null
  
)

export default component.exports